module.exports = __webpack_public_path__ + "img/alleartikler.08101275.png";